var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganisatioen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 1280 1210",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1210.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5699 11502 c-371 -328 -1786 -1580 -3144 -2782 -1359 -1201 -2489 -2203 -2512 -2225 l-41 -40 329 -370 c181 -203 333 -371 338 -373 6 -2 949 828 2098 1844 1148 1017 2434 2154 2857 2529 423 374 773 680 777 680 5 0 1291 -1135 2859 -2523 1568 -1388 2857 -2525 2864 -2528 7 -3 122 119 267 283 140 158 289 327 332 375 l78 87 -1038 918 c-571 505 -1882 1665 -2913 2578 -1031 912 -1998 1768 -2149 1902 -214 190 -277 240 -288 232 -9 -8 -17 -8 -26 -1 -10 8 -171 -129 -688 -586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910 10089 l0 -1201 108 98 c59 53 418 378 798 721 l691 623 6 347 c4 190 7 406 7 480 l0 133 -805 0 -805 0 0 -1201z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4875 8574 c-836 -740 -1845 -1632 -2242 -1982 l-722 -637 0 -2875 c-1 -2870 -1 -2875 20 -2920 29 -64 84 -117 146 -140 53 -20 80 -20 1478 -20 l1425 0 2 1277 c3 1272 3 1278 24 1323 26 58 76 108 134 134 45 21 49 21 1260 21 1211 0 1215 0 1260 -21 58 -26 108 -76 134 -134 21 -45 21 -51 24 -1322 l2 -1278 1425 0 c1398 0 1425 0 1478 20 62 23 117 76 146 140 21 45 21 51 20 2920 l0 2875 -831 735 c-457 404 -1360 1202 -2007 1775 -1658 1467 -1645 1455 -1651 1455 -3 0 -689 -606 -1525 -1346z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisatioen);
export default __webpack_public_path__ + "static/media/organisatioen.2d89537c2066b0ce2f2a8241efe9de28.svg";
export { ForwardRef as ReactComponent };